import '.i{position:fixed;}.ssr-plugin'
import '.as{top:0px;}.ssr-plugin'
import '.b1{left:0px;}.ssr-plugin'
import '.b2{right:0px;}.ssr-plugin'
import '.b3{bottom:0px;}.ssr-plugin'
import '.b4{background-color:rgba(0, 0, 0, 0.25);}.ssr-plugin'
import '.b5{z-index:998;}.ssr-plugin'
import '.b6{transition:opacity 0.3s ease;}.ssr-plugin'
import '.b7{height:100vh;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.v{background-color:var(--palette-white);}.ssr-plugin'
import '.b8{transition:transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);}.ssr-plugin'
import '.b9{z-index:999;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.ae{justify-content:space-between;}.ssr-plugin'
import '.ba{padding:1.5rem;}.ssr-plugin'
import '.bb{border-bottom:var(--border-default);}.ssr-plugin'
import '.bc{flex-shrink:0;}.ssr-plugin'
import '.bd{flex:1;}.ssr-plugin'
import '.be{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { IconButton } from '@app/components/core/button/IconButton'
import { faXmark } from '@fortawesome/pro-regular-svg-icons'
import { PropsWithChildren } from 'react'
import useMediaQuery from '@app/util/useMediaQuery'

export interface DrawerProps extends PropsWithChildren {
  title: string
  open: boolean
  setOpen: (open: boolean) => void
  portal?: HTMLElement
  style?: Style
  side: 'left' | 'right'
}

export const Drawer = ({
  title,
  open,
  setOpen,
  children,
  portal: _portal,
  style,
  side,
}: DrawerProps) => {
  const isMobile = useMediaQuery()

  const translateValue = open ? '0' : side === 'left' ? '-100%' : '100%'

  return (
    <>
      {/* Overlay */}
      <div className="i as b1 b2 b3 b4 b5 b6"
        onClick={() => setOpen(false)}
        style={{
          opacity: open ? 1 : 0,
          pointerEvents: open ? 'auto' : 'none',}}
      />

      {/* Sidebar Panel */}
      <styled.div className="i as b7 n v b8 b9 d e"
        style={{
          [side]: 0,
          maxWidth: isMobile ? '100%' : '30rem',
          borderRadius: isMobile ? 0 : '1.25rem',
          boxShadow: open ? '0 0 15px rgba(0,0,0,0.15)' : 'none',
          transform: `translateX(${translateValue})`,
          ...style,
        }}
      >
        {/* Header */}
        <div className="d t ae ba bb bc"
        >
          <Title.H4 style={{ margin: 0 }}>{title}</Title.H4>
          <IconButton
            icon={faXmark}
            size="small"
            variant="secondary"
            onClick={() => setOpen(false)}
          />
        </div>

        {/* Content */}
        <div className="bd be ba"
        >
          {children}
        </div>
      </styled.div>
    </>
  )
}
